<template>
  <div class="nav-container">
    <div class="nav">
      <div class="btn-box">
        <div
          v-for="(item, index) in navItems"
          :key="index"
          class="btn"
          :class="{
            active: activeIndex === index,
            hover: hoverIndex === index,
          }"
          @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = null"
          @click="handleClick(index)"
          ref="menuItems"
        >
          {{ item.title }}
          <div
            class="underline"
            :class="{ active: activeIndex === index }"
          ></div>
        </div>
      </div>
      <div class="divider-line"></div>
      <div class="underline-indicator" :style="indicatorStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navItems: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every((item) => item.title && item.id);
      },
    },
  },
  data() {
    return {
      activeIndex: 0,
      hoverIndex: null,
      indicatorWidth: 0,
      indicatorLeft: 0,
    };
  },
  computed: {
    indicatorStyle() {
      return {
        transform: `translateX(${this.indicatorLeft}px) scaleX(${
          this.indicatorWidth / 100
        })`,
        transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      };
    },
  },
  watch: {
    // activeIndex(newVal) {
    //   this.$nextTick(this.updateIndicatorPosition);
    // },
  },
  mounted() {
    this.$nextTick(() => {
      // this.updateIndicatorPosition();
      this.setupResizeObserver();
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    handleClick(index) {
      this.activeIndex = index;
      const item = this.navItems[index];
      this.$emit("nav-change", item);
      
      // 如果导航项有path属性，则进行路由跳转
      if (item.path) {
        this.$router.push(item.path);
      }
    },
    // updateIndicatorPosition() {

    //   const activeItem = this.$refs.menuItems[this.activeIndex];
    //   if (activeItem) {
    //     // 改用 offsetLeft（相对父容器的偏移，更稳定）
    //     this.indicatorLeft = activeItem.offsetLeft;
    //     this.indicatorWidth = activeItem.offsetWidth;
    //   }
    // },
    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          // this.updateIndicatorPosition();
        });
      });
      this.resizeObserver.observe(this.$el);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-container {
  width: 100%;
  height: 40%;
  position: relative;
  contain: content;
}

.nav {
  padding-left: 6%;
  width: 100%;
  position: relative;
  padding-bottom: 10px;
  height: auto;
  display: block;
  backface-visibility: hidden;
  background-color: transparent;
}

.btn {
  &.active {
    color: red;
    position: relative; // 给伪元素做定位基准

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0; // 左右撑满，自动对齐文字宽度
      bottom: -9px; // 调整与文字的距离
      height: 2px;
      background-color: rgba(218, 41, 28, 1);
    }
  }
}

.btn-box {
  display: flex;
  width: 1440px;
  margin: 0 auto;
  justify-content: flex-start;

  .btn {
    font-weight: 400;
    letter-spacing: 0.5px;
    text-align: left;
    margin-top: 3%;
    position: relative;
    width: auto;
    min-width: 100px;
    height: 23px;
    line-height: 0px;
    text-align: center;
    color: rgba(47, 49, 51, 1);
    cursor: pointer;
    font-size: 22px;
    margin-right: 60px;
    padding: 0 15px;
    transition: color 0.3s ease;
    will-change: color;

    &.active {
      color: red;
    }
  }
}

.divider-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: rgba(220, 224, 228, 1);
  opacity: 0.5;
}

.underline-indicator {
  position: absolute;
  bottom: 0;
  left: 0.8%;
  width: 4%;
  height: 2px;
  background-color: rgba(218, 41, 28, 1);
  z-index: 2;
  transform-origin: left center;
  will-change: transform;
  backface-visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/Nav.vue